/* VH Live Events (sections/vh-live.liquid).
   PART 1 is COPIED VERBATIM from sections/live-events.liquid L659-765 (its inline <script>): Get Tickets adds
   data-variant-id to the cart (/cart/add.js, then /cart), the live deadline check, expired-event removal and the detail modals.
   Not one line changed, so the network calls and DOM hooks are exactly the live page's.
   PART 2 is new presentation only (deadline countdown text, photo reel drift, reveals). */

/* ===== PART 1: verbatim from sections/live-events.liquid L659-765 ===== */
(function() {
  const vhLiveRoot = document.getElementById('vh-live') || { dataset: {} };
  // Add to cart
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      
      const originalText = this.textContent;
      this.textContent = vhLiveRoot.dataset.i18nAdding || 'Adding...';
      this.disabled = true;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => { window.location.href = '/cart'; })
      .catch(() => {
        this.textContent = vhLiveRoot.dataset.i18nError || 'Error - Try Again';
        this.disabled = false;
        setTimeout(() => { this.textContent = originalText; }, 2000);
      });
    });
  });

  // Check deadlines
  function checkDeadlines() {
    const now = Date.now();
    document.querySelectorAll('[data-deadline]').forEach(card => {
      const deadline = parseInt(card.getAttribute('data-deadline')) * 1000;
      const closedText = card.getAttribute('data-closed-text');
      const btn = card.querySelector('.live-event-btn:not(.closed)');
      
      if (deadline < now && btn) {
        const closedBtn = document.createElement('div');
        closedBtn.className = 'live-event-btn closed';
        closedBtn.textContent = closedText;
        btn.parentNode.replaceChild(closedBtn, btn);
      }
    });
  }

  // Remove expired
  function removeExpired() {
    const now = Date.now();
    document.querySelectorAll('[data-event-end]').forEach(card => {
      const endTime = parseInt(card.getAttribute('data-event-end')) * 1000;
      const hideTime = endTime + 60000;
      
      if (hideTime < now) {
        card.style.transition = 'opacity 0.5s ease-out';
        card.style.opacity = '0';
        setTimeout(() => card.remove(), 500);
      }
    });
  }

  // Modals
  let scrollPosition = 0;
  
  document.querySelectorAll('[data-modal-id]').forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      const modal = document.getElementById(this.getAttribute('data-modal-id'));
      if (modal) {
        scrollPosition = window.pageYOffset;
        modal.classList.add('active');
        document.body.classList.add('modal-open');
        document.documentElement.classList.add('modal-open');
        document.body.style.top = `-${scrollPosition}px`;
      }
    });
  });
  
  document.querySelectorAll('[data-close-modal]').forEach(closer => {
    closer.addEventListener('click', function() {
      const modal = document.getElementById(this.getAttribute('data-close-modal'));
      if (modal) {
        modal.classList.remove('active');
        document.body.classList.remove('modal-open');
        document.documentElement.classList.remove('modal-open');
        document.body.style.top = '';
        window.scrollTo(0, scrollPosition);
      }
    });
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.live-event-modal.active');
      if (activeModal) {
        activeModal.classList.remove('active');
        document.body.classList.remove('modal-open');
        document.documentElement.classList.remove('modal-open');
        document.body.style.top = '';
        window.scrollTo(0, scrollPosition);
      }
    }
  });

  // Init & intervals
  checkDeadlines();
  removeExpired();
  setInterval(() => { checkDeadlines(); removeExpired(); }, 10000);
})();

/* ===== PART 2: presentation only ===== */
(function () {
  var root = document.getElementById('vh-live');
  if (!root || root.getAttribute('data-vh-on')) return;
  root.setAttribute('data-vh-on', '1');
  var all = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
  function left(ms) {
    var s = Math.max(0, ms / 1000) | 0, d = s / 86400 | 0, h = (s % 86400) / 3600 | 0, m = (s % 3600) / 60 | 0;
    return d ? d + 'd ' + p2(h) + 'h ' + p2(m) + 'm' : p2(h) + ':' + p2(m) + ':' + p2(s % 60);
  }
  /* "Registration Ends ..." gets a live countdown; the pill goes away when the deadline passes (the verbatim
     checkDeadlines() above swaps the button to the closed text on its own 10 s cycle) */
  function tickDl() {
    var now = Date.now();
    all('[data-vh-dl]').forEach(function (el) {
      var ms = +el.getAttribute('data-vh-dl') * 1000 - now, cd = el.querySelector('[data-vh-cd]');
      if (ms <= 0) { el.hidden = true; return; }
      if (cd) cd.textContent = ' · ' + left(ms);
    });
  }
  tickDl(); setInterval(tickDl, 1000);

  if (window.VHK && VHK.withGsap) VHK.withGsap(function (ok) {
    if (!ok) return;
    var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
    var reel = root.querySelector('[data-vh-reel]');
    gsap.from(all('.vh-live-lh-h, .vh-live-lh-side'), {autoAlpha: 0, y: 40, duration: 1.1, stagger: .14, ease: 'power3.out', delay: .1});
    if (reel) {
      gsap.from(reel, {autoAlpha: 0, y: 60, duration: 1.3, ease: 'power3.out', delay: .35});
      /* the photo reel moves sideways as you scroll past it (approved in the preview) */
      gsap.fromTo(reel, {x: 0}, {x: function () { return -Math.max(0, reel.scrollWidth - window.innerWidth) * .55; }, ease: 'none',
        scrollTrigger: {trigger: root.querySelector('.vh-live-lh'), start: 'top top', end: 'bottom top', scrub: true, invalidateOnRefresh: true}});
    }
    all('.vh-rv').forEach(function (el) { gsap.fromTo(el, {autoAlpha: 0, y: 48}, {autoAlpha: 1, y: 0, duration: 1.15, ease: 'power3.out', scrollTrigger: {trigger: el, start: 'top 88%', once: true}}); });
    (window.VHK && VHK.refresh ? VHK.refresh() : ScrollTrigger.refresh());
  });
})();
